import React from 'react';
import { ConfirmationStyled } from './ConfirmationBlock.styles';

const ConfirmationBlock = ({ title, img, description, btns }) => {
  return (
    <ConfirmationStyled>
      <div className="task-completed">
        <div className="img-holder">
          <img src={img} alt="img" />
        </div>
        <strong className="title">{title}</strong>
        <span className="text">{description}</span>
        <div className="btn-holder">{btns}</div>
      </div>
    </ConfirmationStyled>
  );
};

export default ConfirmationBlock;
